import { c as _c } from "react/compiler-runtime";
/**
 * Hero block for the Demand Central page. Full-width dark panel with the
 * headline and the "Master Demand" callout card.
 */
export function DemandHeroBlock() {
  const $ = _c(7);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-x-0 top-0 h-1.5 bg-[#ff5a36]" />;
    t1 = <div aria-hidden="true" className="absolute inset-0 opacity-[0.12] [background-image:linear-gradient(to_right,white_1px,transparent_1px),linear-gradient(to_bottom,white_1px,transparent_1px)] [background-size:54px_54px] [mask-image:linear-gradient(to_bottom,black,transparent_85%)]" />;
    t2 = <div aria-hidden="true" className="absolute -right-32 -top-32 h-96 w-96 rounded-full bg-[#ff5a36]/25 blur-3xl" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="max-w-2xl text-lg font-semibold leading-snug text-white/70 sm:text-xl">Your rapid 101 on demand. The key things worth knowing, how it works and where to start, in a few minutes.</p>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="lg:col-span-8">{t3}<h1 className="mt-5 max-w-5xl text-5xl font-black leading-[0.94] tracking-[-0.045em] sm:text-7xl lg:text-[6.5rem]">Be Demanded.<span className="block text-[#ff7354]">Be Purchased.</span></h1><p className="mt-8 max-w-3xl text-2xl font-bold leading-tight text-white sm:text-3xl lg:text-[2.55rem]">Get people to know you, want you and choose you. Then keep them coming back.</p></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <p className="text-xs font-black uppercase tracking-[0.18em] text-[#d63f20]">Master Demand</p>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <section className="relative isolate overflow-hidden border-b border-white/10 bg-[#211d4f] text-white">{t0}{t1}{t2}<div className="relative mx-auto max-w-[1440px] px-5 py-16 sm:px-8 sm:py-24 lg:px-12 lg:py-28"><div className="grid items-end gap-12 lg:grid-cols-12 lg:gap-10">{t4}<div className="lg:col-span-4 lg:pb-2"><div className="border-2 border-gray-950 bg-white p-6 text-gray-950 shadow-[10px_10px_0_0_#ff5a36] sm:p-8">{t5}<div className="mt-5 space-y-4 text-2xl font-black leading-none sm:text-3xl"><p>People know you exist.</p><p>People want you.</p><p>People buy you.</p><p>People keep choosing you.</p></div></div></div></div></div></section>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}